import { render } from "./Relatorios.vue?vue&type=template&id=63044a4f&scoped=true"
import script from "./Relatorios.vue?vue&type=script&lang=js"
export * from "./Relatorios.vue?vue&type=script&lang=js"

import "./Relatorios.vue?vue&type=style&index=0&id=63044a4f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63044a4f"]])

export default __exports__